module.exports = __webpack_public_path__ + "static/media/privatePassenger.57123007.svg";